<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>实测统计</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="题库">
              <Select v-model="bank" placeholder="请选择题库">
                <Option value="comp">综合</Option>
                <Option value="speak">口语</Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="业务键">
              <Input v-model="queryParam.businessCode" placeholder="如 L1-L-U1-VR-Q001"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12" v-if="bank === 'comp'">
            <Form-item label="技能">
              <Select v-model="queryParam.skill" clearable placeholder="请选择技能">
                <Option value="Listening">听力 Listening</Option>
                <Option value="Reading">阅读 Reading</Option>
                <Option value="Writing">写作 Writing</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" :listUrl="listUrl"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
  </div>
</template>

<script>
import { questionTypeLabel, skillLabel } from './mex-question-type'

export default {
  name: 'MexItemStatsList',
  data () {
    return {
      searchLoading: false,
      reload: 0,
      bank: 'comp',
      queryParam: {},
      tableColumns: [
        { title: '题头ID', key: 'questionId', width: 90, ellipsis: true },
        { title: '业务键', key: 'businessCode', width: 220, ellipsis: true },
        { title: '技能', key: 'skill', width: 140, ellipsis: true, render: (h, params) => h('span', skillLabel(params.row.skill)) },
        { title: '级别', key: 'levelCode', width: 80, ellipsis: true },
        { title: '题型', key: 'questionType', minWidth: 220, ellipsis: true, render: (h, params) => h('span', questionTypeLabel(params.row.questionType, params.row.skill)) },
        { title: '曝光', key: 'exposureCount', width: 80, ellipsis: true },
        { title: '作答', key: 'answerCount', width: 80, ellipsis: true },
        { title: '答对', key: 'correctCount', width: 80, ellipsis: true },
        { title: '通过率', key: 'passRate', width: 90, ellipsis: true },
        { title: '均时秒', key: 'avgDurationSec', width: 90, ellipsis: true }
      ]
    }
  },
  computed: {
    listUrl () {
      return this.bank === 'speak' ? '/mex/stats/speak' : '/mex/stats/comp'
    }
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';
</style>



// WEBPACK FOOTER //
// MexItemStatsList.vue?158d48c8